import React from 'react';
import { combinedSVGIcons } from 's2s-svg-icons-combined';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

const SettingsButton = styled.div`
  align-items: center;
  background-color: ${colorGrid.gray0};
  border-bottom: 2px solid ${colorGrid.gray4};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  height: 64px;
  padding: 0 10px 0 15px;

  :hover {
    background-color: rgba(36, 57, 145, 0.04);
    border-bottom: 2px solid ${colorGrid.gray4};
  }

  :focus{
    border: 2px solid ${colorGrid.blue6};
    outline : none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow : none;
  }
`;  

const SettingsButtonLabel = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const TitleAndDescriptionContainer = styled.div`
  font-family: Open Sans;
  margin-left: 16px;
`;

const Title = styled.div`
  color: #001221;
  font-size: 14px;
  font-weight: 600;
`;

const Description = styled.div`
  color: #4c5863;
  font-size: 14px;
`;

const SVGStyle = {
  fill: '#4c5863',
  height: '24px',
  width: '24px',
};

const arrowIconStyle = {
  fill: '#7F888F',
  height: '24px',
  width: '24px',
};

const SettingsNavButton = ({ cbClick, description, svgType, title }) => {
  const buttonOnKeyDown = (e) => {
    switch (e.keyCode) {
      case 32:
        this.props.cbClick();
        break;
      case 13:
        this.props.cbClick();
        break;
      default:
        break;
    }
  };

  const DynamicSVG = combinedSVGIcons[svgType] || combinedSVGIcons['SettingsIconSVG'];
  const ArrowSVG = combinedSVGIcons['ChevronRightIconSVG'];

  return (
    <SettingsButton tabIndex="0" onKeyDown={buttonOnKeyDown} onClick={cbClick}>
      <SettingsButtonLabel>
        <DynamicSVG svgStyle={SVGStyle} />
        <TitleAndDescriptionContainer>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </TitleAndDescriptionContainer>
      </SettingsButtonLabel>
      <ArrowSVG svgStyle={arrowIconStyle} />
    </SettingsButton>
  );
};

SettingsNavButton.propTypes = {
  cbClick: PropTypes.func,
  description: PropTypes.string,
  svgType: PropTypes.string,
  title: PropTypes.string
};

SettingsNavButton.defaultProps = {
  cbClick: () => { console.log("Please define a callback function for cbClick in SettingsButton"); },
  description: 'Change your settings.',
  svgType: 'SettingsIconSVG',
  title: 'Settings'
};

export default injectIntl(SettingsNavButton);
